module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAcCAYAAABsxO8nAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADlSURBVHgB7dNBCoJAFAbg/40ZBC1s0T5v4BU8QXSDPJn7Vt0gu4E3iFZtXQRCQi9HSUSd0ckWRf0gyJs33zCOAwzIKXQc+eh6CAOQ2dw+yPf0mvlukCTGUIUQeUWBOVZhNBh5RoGREaLByBhRYPQS0oGRHuH4DjoLYF2sStiDsWLAa2JCh6RW5ucr1T9qMrVushZXlXyOnFtA8lcjqu+yRNxN+5gXea2NAaI9qEa6sbJfNAf7EFX/pDkIg9T7Bd6UP/SN0KS3gzhiLq8Pg4/4vRSbv+yWWxIUYkQ+9fhtK+IMAUbkAaTknH7VLYm6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/icon-upgrade.png
// module id = tcnn
// module chunks = 0